<template>
  <div>
    <div class="product-filter">
      <div class="form-control-container">
        <div class="form-group">
          <img
            class="form-search-icon"
            :src="`${$root.cdnUrl}assets/icon-search.png`"
          >
          <input
            type="text"
            class="form-control"
            placeholder="Ürün Adı Ara"
            v-model="params.productTitle"
            @input="onInput"
          >
        </div>
        <button @click="showModal">
          <img
            alt="filter"
            :src="btnFilter"
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import routerPush from '@/mixins/routerPush';

let productTitleTimeout = null;

export default {
  name: 'ListFilter',
  mixins: [routerPush],
  props: {
    supplierProductQueryType: {
      type: [String, null],
      default: null,
    },
  },
  data () {
    return {
      params: {},
    };
  },
  computed: {
    btnFilter () {
      return this.$root.cdnUrl + (this.showFilterModal ? 'assets/btn-filter.svg' : 'assets/btn-filter-a.svg');
    },
  },
  methods: {
    onInput () {
      clearTimeout(productTitleTimeout);
      productTitleTimeout = setTimeout(() => this.handleFilter(), 700);
    },
    handleFilter () {
      this.$emit('onFilter', this.params);
    },
    showModal () {
      this.$emit('openFilterModal');
    },
  },
  created () {
    if (this.$route?.query) {
      this.params = this.$route.query;
    }
    this.handleFilter();
  },
};
</script>

<style lang="scss" scoped>
  .product-filter {
    position: relative;
    padding: 15px;

    .form-control-container {
      position: relative;
      display: flex;

      .form-group {
        position: relative;
        flex: 1;
      }
      .form-search-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15px;
        width: 18px;
        height: 18px;
      }
      .form-control {
        padding-left: 43px;
        padding-right: 60px;
        height: 40px;
      }
      button {
        display: inline-block;
        background-color: transparent;
        border: 0;
        padding: 0;
        height: 40px;
        margin-left: 10px;

        img {
          display: inline-block;
          height: 40px;
        }
      }
    }
  }
</style>
